import React from 'react';

import { Select } from '@app/components/UI/Select/Select';
import { Option } from '@app/components/UI/Select/Option';
import { timeFormatOptions } from '@app/components/UI/Inputs/LocalSelectOptions';
import { Option as IOption } from '@app/components/UI/Inputs/LocalSelect';

interface TimeFormatSelectProps {
	value: string;
	onChange: (value: string) => void;
}

export const TimeFormatSelect: React.FC<TimeFormatSelectProps> = ({ value, onChange }: TimeFormatSelectProps) => (
	<Select
		value={value}
		onChange={(value: string) => onChange(value)}
		placeholder="Select the time format"
		showClear={false}
	>
		{
			timeFormatOptions.map((item: IOption) => (
				<Option key={item.value} value={item.value}>
					{item.text}
				</Option>
			))
		}
	</Select>
);
